<mat-form-field appearance="fill" fxFlexFill>
    <mat-label>Nivel educacional</mat-label>
    <mat-select [(ngModel)]="this.levelId" (selectionChange)="onChangeLevel()">
        <mat-option value="">- Seleccione Nivel-</mat-option>
        <mat-option *ngFor="let level of this.levelList" 
        [value]="level.id">
        {{level.name}}
        </mat-option>
    </mat-select>
</mat-form-field>